import { useUserStore } from '@/hooks/useAccount';
import { FacebookModule } from '@/modules/facebook';
import { TikTokModule } from '@/modules/tiktok';
import { webCampaign } from '@/modules/webCampaign';

import { canLogEvents } from './canLogEvents';

export const identifyTikTokUser = (params?: {
  email?: string | null;
  externalId?: string | null;
}) => {
  if (!canLogEvents()) {
    return;
  }

  const { id, email: storedEmail } = useUserStore.getState();
  const email = (params?.email ?? storedEmail)?.toLowerCase().trim();
  const externalId = params?.externalId ?? id;

  if (!email && !externalId) {
    return;
  }

  TikTokModule.identify({
    ...(email ? { email } : {}),
    ...(externalId ? { external_id: externalId } : {}),
  });
};

export const trackOnboardingComplete = (params?: { email?: string }) => {
  if (canLogEvents()) {
    identifyTikTokUser({ email: params?.email });

    TikTokModule.trackEvent('AddToCart');
    TikTokModule.trackEvent('CompleteRegistration');

    if (webCampaign.canLogFBEvents()) {
      FacebookModule.trackEvent('Lead');
    }
  }
};
